import './CSS/MyProjectsStyle.css';
function MyProjects (props) {
    return (
      <p id="myPortfolioText"> Projects </p>  
    );
  }
  
  export default MyProjects;